module.exports = __webpack_public_path__ + "static/media/Header.1483fec7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/Header.svg
// module id = 384
// module chunks = 0